import {getSortedNodesByLevels} from "./NodeLevelService";
import config from "../config/GraphViewConfig";

function computeCoordinates(nodes, adj) {

    const nodesByLevels = getSortedNodesByLevels(nodes, adj) // matrix with nodes distributed by levels

    const levelWidths = nodesByLevels.map(nodes => {
        let width = nodes.reduce((acc, cur) => {
                return acc + cur.width + config.design.nodesDefaultHorizontalGap
        }, 0)

        return width - config.design.nodesDefaultHorizontalGap
    })

    const longestLevel = levelWidths.reduce(
        (bestIdx, currentVal, idx, array) =>
            currentVal > array[bestIdx] ? idx : bestIdx,
        0
    );

    nodesByLevels.forEach((nodes,level) => {
        const startX  = ((levelWidths[longestLevel] - levelWidths[level]) / 2) + config.design.container.defaultLeftPadding

        let startY = config.design.container.defaultTopPadding

        for (let i = 0; i < level; i++){
            let levelMaxHeight = 0
            nodesByLevels[i].forEach((node) => {
                levelMaxHeight = Math.max(levelMaxHeight, node.height)
            })
            startY += levelMaxHeight + config.design.levelsDefaultVerticalGap
        }

        let currX = 0

        nodes.forEach((node,index) => {
            node.y = startY
            node.x = startX + currX
            currX += node.width + config.design.nodesDefaultHorizontalGap
        })
    })

}

export {computeCoordinates};


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/services/NodeCoordinateService.js